import { render, staticRenderFns } from "./SOCScreen1.vue?vue&type=template&id=9afa1872"
import script from "./SOCScreen1.vue?vue&type=script&lang=js"
export * from "./SOCScreen1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports